import { useTranslation } from 'react-i18next'
import { NAV } from '@/components/layout/nav'
import { useAuth } from '@/lib/auth/AuthProvider'
import type { WidgetConfig } from '../types'
import { WIDGET_META } from './meta'
import { WIDGETS } from './registry'
import { PersonalBadge, WidgetFrame } from './WidgetFrame'

const navPermFor = (to: string) => NAV.flatMap((g) => g.items).find((i) => i.to === to)?.perm

export function WidgetRenderer({ config, className }: { config: WidgetConfig; className?: string }) {
  const { t } = useTranslation()
  const { can } = useAuth()
  const meta = WIDGET_META[config.type]
  const { icon, Body } = WIDGETS[config.type]
  const to = meta.to && can(navPermFor(meta.to)) ? meta.to : undefined

  return (
    <WidgetFrame
      icon={icon}
      title={t(`dashboard.widgets.${config.type}.title`)}
      tone={config.tone}
      density={config.density}
      frameless={meta.frameless}
      badge={meta.personal ? <PersonalBadge /> : undefined}
      to={to}
      className={className}
    >
      <Body config={config} />
    </WidgetFrame>
  )
}
